import throttle from "lodash/throttle";
import debounce from "lodash/debounce";

export default class StickyNav {
  constructor() {
    var header = $(".m-site-header"); // the header above main nav
    var mainNav = $("#main-nav");

    if (mainNav.length > 0) {
      var headerHeight = header.outerHeight();

      mainNav.css("margin-bottom", "-" + mainNav.outerHeight().toString() + "px");

      mainNav.next().css("margin-top", mainNav.outerHeight());

      var onResize = debounce(function () {
        var _mainNav = $("#main-nav");
        _mainNav.css("margin-bottom", "-" + _mainNav.outerHeight().toString() + "px");
        _mainNav.next().css("margin-top", _mainNav.outerHeight());
      }, 250);

      var onScroll = throttle(function () {
        if ($(window).width() > 768) {
          var _mainNav = $("#main-nav");

          if (_mainNav && $(this).scrollTop() >= headerHeight) {
            _mainNav.addClass("nav-sticky");
          } else {
            _mainNav.removeClass("nav-sticky");
          }
        }
      }, 20);

      $(window).resize(onResize);
      $(window).scroll(onScroll);
    }
  }
}
